// ORDERS
export const FETCH_CALL_CENTER_ORDERS_SUCCESS = "FETCH_CALL_CENTER_ORDERS_SUCCESS";
export const FETCH_CALL_CENTER_ORDERS_SAGA = "FETCH_CALL_CENTER_ORDERS_SAGA";
// LOCATIONS
export const FETCH_CALL_CENTER_LOCATIONS_SUCCESS = "FETCH_CALL_CENTER_LOCATIONS_SUCCESS";
export const FETCH_CALL_CENTER_LOCATIONS_SAGA = "FETCH_CALL_CENTER_LOCATIONS_SAGA";
//PUT ORDER
export const PUT_CALL_CENTER_ORDER_SUCCESS = "PUT_CALL_CENTER_ORDER_SUCCESS";
export const PUT_CALL_CENTER_ORDER_SAGA = "PUT_CALL_CENTER_ORDER_SAGA";
//POST ORDER
export const POST_ORDER_TO_LOCATION_SUCCESS = "POST_ORDER_TO_LOCATION_SUCCESS";
export const POST_ORDER_TO_LOCATION_SAGA = "POST_ORDER_TO_LOCATION_SAGA"; 
